import { takeEvery, fork, put, all, call, takeLatest } from "redux-saga/effects";
import { ClassSubtopicOverallReportService, ClassSubtopicSkillReportService, DownloadReport, FetchCTQuestionService, ResetCompetition, SchoolSubtopicOverallReportService, SchoolSubtopicSkillReportService } from "../services/reports";
import { SCHOOL_SUBTOPIC_OVERALL_REPORT_REQUESTED, SCHOOL_SUBTOPIC_OVERALL_REPORT_SUCCESS, SCHOOL_SUBTOPIC_OVERALL_REPORT_FAILURE, CLASS_SUBTOPIC_OVERALL_REPORT_SUCCESS, CLASS_SUBTOPIC_OVERALL_REPORT_FAILURE, CLASS_SUBTOPIC_OVERALL_REPORT_REQUESTED, SCHOOL_SUBTOPIC_SKILL_REPORT_SUCCESS, SCHOOL_SUBTOPIC_SKILL_REPORT_FAILURE, CLASS_SUBTOPIC_SKILL_REPORT_SUCCESS, CLASS_SUBTOPIC_SKILL_REPORT_FAILURE, SCHOOL_SUBTOPIC_SKILL_REPORT_REQUESTED, CLASS_SUBTOPIC_SKILL_REPORT_REQUESTED, FETCH_CT_QUESTION, FETCH_CT_QUESTION_SUCCESS, FETCH_CT_QUESTION_FAILURE, SUBTOPIC_REPORT_RESET, SELECT_COMPETITION, SELECT_STUDENT, SELECT_CLASS, SELECT_SCHOOL, COMPETITION_RESET_REQUESTED, COMPETITION_RESET_FAILURE, COMPETITION_RESET_SUCCESS, DOWNLOAD_REPORT_REQUESTED, DOWNLOAD_REPORT_SUCCESS, DOWNLOAD_REPORT_FAILURE } from "./actionTypes"


function* getSchoolSubtopicOverallReport(action) {
    try {
      const resp = yield call(SchoolSubtopicOverallReportService, action.payload);
      if(resp.status < 400) {
        yield put({
          type: SCHOOL_SUBTOPIC_OVERALL_REPORT_SUCCESS,
          resp
        });
      }
      else yield put({
        type: SCHOOL_SUBTOPIC_OVERALL_REPORT_FAILURE,
        resp
      });
    }
    catch(e) {
      console.error(e,"THIS IS ERROR")
      yield put({
        type: SCHOOL_SUBTOPIC_OVERALL_REPORT_FAILURE,
        message: e.message
      });
    }
}

function* getClassSubtopicOverallReport(action) {
    try {
      const resp = yield call(ClassSubtopicOverallReportService, action.payload);
      if(resp.status < 400) {
        yield put({
          type: CLASS_SUBTOPIC_OVERALL_REPORT_SUCCESS,
          resp
        });
      }
      else yield put({
        type: CLASS_SUBTOPIC_OVERALL_REPORT_FAILURE,
        resp
      });
    }
    catch(e) {
      console.error(e,"THIS IS ERROR")
      yield put({
        type: CLASS_SUBTOPIC_OVERALL_REPORT_FAILURE,
        message: e.message
      });
    }
}

function* getSchoolSubtopicSkillReport(action) {
    try {
      const resp = yield call(SchoolSubtopicSkillReportService, action.payload);
      if(resp.status < 400) {
        yield put({
          type: SCHOOL_SUBTOPIC_SKILL_REPORT_SUCCESS,
          resp
        });
      }
      else yield put({
        type: SCHOOL_SUBTOPIC_SKILL_REPORT_FAILURE,
        resp
      });
    }
    catch(e) {
      console.error(e,"THIS IS ERROR")
      yield put({
        type: SCHOOL_SUBTOPIC_SKILL_REPORT_FAILURE,
        message: e.message
      });
    }
}

function* getClassSubtopicSkillReport(action) {
    try {
      const resp = yield call(ClassSubtopicSkillReportService, action.payload);
      if(resp.status < 400) {
        yield put({
          type: CLASS_SUBTOPIC_SKILL_REPORT_SUCCESS,
          resp
        });
      }
      else yield put({
        type: CLASS_SUBTOPIC_SKILL_REPORT_FAILURE,
        resp
      });
    }
    catch(e) {
      console.error(e,"THIS IS ERROR")
      yield put({
        type: CLASS_SUBTOPIC_SKILL_REPORT_FAILURE,
        message: e.message
      });
    }
}
function* watchFetchCtQuestion(action) {
    try {
      const resp = yield call(FetchCTQuestionService, action.payload);
      if(resp.status < 400) {
        yield put({
          type: FETCH_CT_QUESTION_SUCCESS,
          resp
        });
      }
      else yield put({
        type: FETCH_CT_QUESTION_FAILURE,
        resp
      });
    }
    catch(e) {
      console.error(e,"THIS IS ERROR")
      yield put({
        type: FETCH_CT_QUESTION_FAILURE,
        message: e.message
      });
    }
}
function* watchResetReportData(action) {
    try {
      yield put({
        type: SUBTOPIC_REPORT_RESET
      });;
    }
    catch(e) {
      console.error(e,"THIS IS ERROR")
    }
}

function* resetCompetition(action){
  try {
    const resp = yield call(ResetCompetition, action.competitionId, action.classCode, action.studentId, action.start_time, action.end_time);
    if(resp.status < 400) {
      yield put({
        type: COMPETITION_RESET_SUCCESS,
        resp
      });
    }
    else yield put({
      type: COMPETITION_RESET_FAILURE,
      resp
    });
  }
  catch(e) {
    yield put({
      type: COMPETITION_RESET_FAILURE,
      message: e.message
    });
  }
}

function* downloadReport(action){
  try {
    const resp = yield call(DownloadReport, action.competitionId, action.schoolId);
    if(resp.status < 400) {
      yield put({
        type: DOWNLOAD_REPORT_SUCCESS,
        resp
      });
    }
    else yield put({
      type: DOWNLOAD_REPORT_FAILURE,
      resp
    });
  }
  catch(e) {
    yield put({
      type: DOWNLOAD_REPORT_FAILURE,
      message: e.message
    });
  }
}

function* ReportSaga() {
    yield all([
        takeLatest(SCHOOL_SUBTOPIC_OVERALL_REPORT_REQUESTED, getSchoolSubtopicOverallReport),
        takeLatest(CLASS_SUBTOPIC_OVERALL_REPORT_REQUESTED, getClassSubtopicOverallReport),
        takeLatest(SCHOOL_SUBTOPIC_SKILL_REPORT_REQUESTED, getSchoolSubtopicSkillReport),
        takeLatest(CLASS_SUBTOPIC_SKILL_REPORT_REQUESTED, getClassSubtopicSkillReport),
        takeLatest(FETCH_CT_QUESTION, watchFetchCtQuestion),
        takeLatest(SELECT_COMPETITION, watchResetReportData),
        takeLatest(SELECT_STUDENT, watchResetReportData),
        takeLatest(SELECT_CLASS, watchResetReportData),
        takeLatest(SELECT_SCHOOL, watchResetReportData),
        takeLatest(COMPETITION_RESET_REQUESTED,resetCompetition),
        takeLatest(DOWNLOAD_REPORT_REQUESTED, downloadReport)
    ]);
}
  
export default ReportSaga;